import { _GLOBALS } from './globals.js';
import { view as WalletSelectionView, init as InitWalletSelection } from './walletSelectionView.js';
import { view as PaymentView, init as InitPayment } from './paymentView.js';
import { view as ReferralConfigView, init as InitReferralConfig } from './referralConfigView.js';
import $ from 'jquery';

const mainContent = document.getElementById('main-content');

export const Router = {
    PagesInitialized: [],
    To: async (selectedPage = "walletSelection", data = null) => {
        let page = '';
        let initPage = null;
        switch (selectedPage) {
            case "walletSelection":
                page += await WalletSelectionView(data);
                initPage = InitWalletSelection;
                break;
            case "payment":
                page += await PaymentView(data);
                initPage = InitPayment;
                break;
            case "referral_config":
                page += await ReferralConfigView(data);
                initPage = InitReferralConfig;
                break;
        }

        
        const current_page = $('.page-view');
        if(_GLOBALS.DebugMode) console.log("currentPage", selectedPage);
        if(current_page.length > 0) {
            //$(mainContent).append(page);
            switchPage(page);
        } else {
            $(mainContent).html(page).find('.page-view').addClass('active');
        }
        //$(app_content).html(page);

        await initPage();
        /*if(initPage !== null && !Router.PagesInitialized.includes(selectedPage)) {
         Router.PagesInitialized.push(selectedPage);
         await initPage();
         }*/
    }
};

const switchPage = (newPageContent) => {
    const currentPage = $(mainContent).find(".page-view.active");

    $(mainContent).append(newPageContent);
    const newPage = $('.page-view:nth-child(2)');

    // Force style recalculation before adding classes
    newPage[0].offsetHeight; // Trigger reflow to ensure styles are recalculated

    setTimeout(() => {
        newPage.addClass("active");
        currentPage.addClass("exit");
    }, 0); // Ensure both transitions happen in the same frame
    
    // Handle transition end for the new page to become active
    newPage.on("transitionend", () => {
        currentPage.remove();
    });
}

window.Router = Router;